<template>
  <v-treeview
    activatable
    open-on-click
    :items="TreeItems"
    item-key="categoryid"
  >
    <template slot="label" slot-scope="{ item }">
      <v-simple-table fixed-header>
        <template v-slot:default>
          <tr>
            <td
              style="width: 25%"
              class="text-left"
              v-text="item.categoryname"
            ></td>
            <td style="width: 25%" class="text-center">
              <p v-if="item.status == 0">
                <span>
                  <i class="status fa fa-times-circle red--text"></i>
                </span>
              </p>
              <p v-else-if="item.status == 1">
                <span>
                  <i class="status fa fa-check-circle green--text"></i>
                </span>
              </p>
            </td>
            <td style="width: 25%" class="text-center">
              <template>
                <v-icon
                  title="Add"
                  style="margin-right: 10px"
                  small
                  @click.stop="addChild(item)"
                  color="success"
                >
                  mdi-plus-circle
                </v-icon>
                <v-icon
                  title="Details"
                  style="margin-right: 10px"
                  small
                  @click.stop="getDetails(item)"
                  color="warning"
                >
                  mdi-information
                </v-icon>

                <v-icon
                  title="Edit"
                  small
                  class="mr-2"
                  color="#1976D2"
                  @click.stop="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  title="Delete"
                  small
                  @click.stop="deleteDialog(item)"
                  color="#FF5252"
                >
                  mdi-delete
                </v-icon>
              </template>
            </td>
          </tr>
        </template>
      </v-simple-table>
    </template>
  </v-treeview>
</template>
<script>
export default {
  props: ["TreeItems", "DialogDetails"],
  data() {
    return {
      items: [],
    };
  },
  methods: {
    addChild(item) {
      this.$router.push({
        name: "AddCategoryChild",
        params: { parentID: item.categoryid },
      });
    },
    getDetails(item) {
      this.$emit("DialogDetailsView", item);
    },
    deleteDialog(item) {
      this.$emit("deleteDialog", item);
    },
    editItem(item) {
      this.$router.push({
        name: "EditCategory",
        params: { categoryID: item.categoryid },
      });
    },
  },
};
</script>   